import React, { useState, useEffect, useRef } from "react";
import "./Projects.css";

function ProjectsDesign({
  title,
  image,
  images,
  description,
  problem,
  collaborators,
  designTools,
  projectImage1,
  userFlowImage,
  wireFrameImage,
  highFidelityImage,
}) {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);

  const handleShowPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  useEffect(() => {
    function handleClickOutside(event) {
      console.log("popupRef:", popupRef.current);
      console.log("event.target:", event.target);
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClosePopup();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef, handleClosePopup]);

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % 3);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.classList.add("popup-open");
    } else {
      document.body.classList.remove("popup-open");
    }
  }, [showPopup]);

  return (
    <div className="col-sm-6 col-md-6 mb-4 pb-2">
      <div className="card" onClick={handleShowPopup}>
        <img className="card-img-top" src={image} alt="Card cap" />
        <div className="card-body">
          <h5 className="card-title text-center">{title}</h5>
        </div>
      </div>

      {showPopup && (
        <div className="popup">
          <div ref={popupRef} className="popup-inner">
            <button className="popup-close" onClick={handleClosePopup}>
              x
            </button>
            <div
              id="carouselExampleControls"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {images.map((image) => (
                  <div
                    key={image.id}
                    className={`carousel-item ${
                      image.id === 1 ? "active" : ""
                    }`}
                  >
                    <img
                      src={image.src}
                      className="d-block w-100"
                      alt={image.alt}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev custom-btn-class"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden"></span>
              </button>
              <button
                className="carousel-control-next custom-btn-class"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden"></span>
              </button>
            </div>
            <div className="text-center pt-2">
              <h4 className="tech-title">{title}</h4>

              <p className="pt-2">{description}</p>
              <p className="pt-2 bold">
                Timeline: <span> 10 weeks</span>
              </p>
              <p className="pt-2 bold">
                Role: <span>UX/UI Designer & Researcher</span>
              </p>
              <p className="pt-2 bold">
                Context: <span>Case Study - Google UX Design Certificate</span>
              </p>
              <p className="pt-2 bold">
                Deliverables:
                <span>
                  Mobile app, Lo-fi Prototype, Hi-fi Prototype, User Testing
                </span>
              </p>
              <img src={projectImage1} />
              <h5 className="pt-2 bold">Problem</h5>
              <p className="pt-2">{problem}</p>
              <h5 className="pt-2 bold">User Flow</h5>
              <img src={userFlowImage} />
              <h5 className="pt-2 bold"> Wireframes</h5>
              <img src={wireFrameImage} />
              <h5 className="pt-2 bold">Highfidelity Prototype</h5>
              <img src={highFidelityImage} />
              <h6 className="tech-title pt-2">Designed by:</h6>
              <p>{collaborators}</p>

              <h6 className="tech-title">Design Tools that I used:</h6>
              <div className="tech-stack">
                {designTools.map((tech) => (
                  <span key={tech} className="tech">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectsDesign;
